import { asApiFailure } from "@utils/apiFailure";

// Admin-facing copy for the certificate re-review actions (E12-S5 / #240).
// Both hooks suppress the generic toast, so each failure the server can
// return is named here — a 409 (not Approved) and a 403 (not an admin) are
// different facts and must not collapse into "something went wrong".

const ACKNOWLEDGE_GENERIC_MESSAGE =
    "Something went wrong while acknowledging. Please try again.";

export const acknowledgeErrorMessage = (error: unknown): string => {
    const failure = asApiFailure(error);

    switch (failure?.status) {
        case 403:
            return "You do not have permission to acknowledge certificates.";

        case 404:
            return "This location no longer exists. It may have been deleted.";

        case 409:
            return "This location is not approved, so its certificate cannot be acknowledged. Refresh to see its current status.";

        default:
            return ACKNOWLEDGE_GENERIC_MESSAGE;
    }
};

const DOWNLOAD_GENERIC_MESSAGE =
    "The download failed. Please try again.";

// `subject` names what the 403 refused: "certificates" on a location's
// certificate list, "this file" on an organization's files (#428), which are
// not all certificates.
export const downloadErrorMessage = (
    error: unknown,
    subject: string,
): string => {
    const failure = asApiFailure(error);

    switch (failure?.status) {
        case 403:
            return `You do not have permission to download ${subject}.`;

        case 404:
            return "This file is no longer available.";

        default:
            return DOWNLOAD_GENERIC_MESSAGE;
    }
};
